import {type CSSProperties, type PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {useAccordionContext} from "../hooks/use_accordion_context";
import type {AccordionTheme} from "../types/AccordionTheme";

import * as styles from "./Content.module.css";

export interface IProps {
    className?: string;
    wrapClassName?: string;
    wrapStyle?: CSSProperties;
}

type ClassName = keyof typeof styles;

const getContentTheme = (theme: AccordionTheme) => `content${capitalize(theme)}` as ClassName;

export const Content = (props: PropsWithChildren<IProps>) => {
    const context = useAccordionContext(Content.name);

    return (
        <div className={cn(styles.wrapper, context.expanded ? styles.expanded : styles.collapsed, props.wrapClassName)} style={props.wrapStyle}>
            <div className={cn(styles.content, styles[getContentTheme(context.theme)])}>
                <div className={cn(styles.contentInner, props.className)}>{props.children}</div>
            </div>
        </div>
    );
};
import {type CSSProperties, type PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {useAccordionContext} from "../hooks/use_accordion_context";
import type {AccordionTheme} from "../types/AccordionTheme";

import * as styles from "./Content.module.css";

export interface IProps {
    className?: string;
    wrapClassName?: string;
    wrapStyle?: CSSProperties;
}

type ClassName = keyof typeof styles;

const getContentTheme = (theme: AccordionTheme) => `content${capitalize(theme)}` as ClassName;

export const Content = (props: PropsWithChildren<IProps>) => {
    const context = useAccordionContext(Content.name);

    return (
        <div className={cn(styles.wrapper, context.expanded ? styles.expanded : styles.collapsed, props.wrapClassName)} style={props.wrapStyle}>
            <div className={cn(styles.content, styles[getContentTheme(context.theme)])}>
                <div className={cn(styles.contentInner, props.className)}>{props.children}</div>
            </div>
        </div>
    );
};
